import moment, { Moment } from 'moment';
import { getDateFormatForLocales } from 'src/formio/components/Datetime/utils';

const convertToServerDate = (value: Moment | string) => {
    return format(value, 'YYYY-MM-DD');
};

const format = (
    value: Moment | string,
    format = getDateFormatForLocales().appFormat,
) => {
    const mValue = moment.isMoment(value) ? value : moment(value);

    return mValue.format(format);
};

export const DateHelper = {
    convertToServerDate,
    format,
};
